import React, {Component, PropTypes} from 'react';
import Header from './header.js';
import Footer from './footer.js';
import { Routes, Route, Outlet, Link } from "react-router-dom";
import PromoChecker from "./../../Promotions/promo-modal";

const Layout = () => {
	  	 return (
            <div >
            <><Header></Header></>
             <PromoChecker />
            <> <Outlet></Outlet></>
             <> <Footer></Footer></>
            </div>
        
    );
	  }	
      export default Layout;